// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZLPk","label":"styles_label__1vkEC"};